import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { FileText, Download, Clock, CheckCircle, ArrowLeft, ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogClose } from '@/components/ui/dialog';
import { useNavigate, Link } from 'react-router-dom';

const TaxLiabilityRemoval = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Header />
      
      <section className="pt-32 pb-20 bg-background">
        <div className="max-w-4xl mx-auto px-4">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/diy-processes')}
            className="mb-8 text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to DIY Processes
          </Button>

          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="p-4 rounded-xl bg-primary/10">
                <FileText className="h-12 w-12 text-primary" />
              </div>
            </div>
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-6">
              Zero your Current Tax Liability with the IRS
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Understand Federal Taxes Are Not For Constitutional Americans. Read, Learn, and Stop Paying Federal Taxes At Once
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <Clock className="h-8 w-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">Time Estimate</h3>
              <p className="text-muted-foreground">3-5 weeks</p>
            </div>
            
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <Download className="h-8 w-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">Templates</h3>
              <p className="text-muted-foreground">3 templates included</p>
            </div>
          </div>

          <div className="bg-card border border-border rounded-xl p-8 mb-8">
            <h2 className="font-rockwell text-2xl font-semibold text-foreground mb-6">
              What You'll Learn
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-foreground mb-3">Essential Knowledge</h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    Why you are not responsible for federal taxes
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    End tax liability literally today
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    You are federal tax exempt
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-3">Practical Skills</h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    Notifying employment
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    IRS communication and correspondence
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-green-600 mr-2 mt-1 flex-shrink-0" />
                    Documentation and filing requirements
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="text-center mb-8">
            <h2 className="font-rockwell text-2xl font-semibold text-foreground underline">
              Start below
            </h2>
          </div>

          {/* Single Step */}
          <div className="flex justify-center">
            <Link to="/category/irs-taxes/videos" className="group cursor-pointer">
              <div className="bg-card border border-border rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:border-primary/50 min-h-[160px] flex flex-col justify-between max-w-md">
                <div>
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 mb-4">
                    <span className="text-xl font-bold text-primary">1</span>
                  </div>
                  <h3 className="font-rockwell text-lg font-semibold text-foreground mb-3 leading-tight">
                    Learn why you are not liable to pay federal taxes ever again
                  </h3>
                </div>
                <Button variant="outline" size="sm" className="w-full mt-4 group-hover:border-primary/50 transition-colors">
                  Open Resources
                </Button>
              </div>
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default TaxLiabilityRemoval;